/**
 * mm-slideshow.js
 * Image / video carousel for [data-mm-slideshow]. Idempotent. Arrows, dots,
 * keyboard, pointer drag and touch. Pause video when leaving a slide.
 */
(function () {
  var THRESHOLD_PX = 40;
  var THRESHOLD_RATIO = 0.15;

  function pauseVideos(root) {
    root.querySelectorAll('video').forEach(function (v) {
      try {
        v.pause();
      } catch (e) {}
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-mm-ss-ready') === '1') return;
    root.setAttribute('data-mm-ss-ready', '1');

    var track = root.querySelector('[data-mm-ss-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mm-ss-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mm-ss-dot]'));
    var prev = root.querySelector('[data-mm-ss-prev]');
    var next = root.querySelector('[data-mm-ss-next]');
    var viewport = root.querySelector('[data-mm-ss-viewport]');
    if (!track || slides.length < 1) return;

    var index = 0;
    var startX = 0;
    var deltaX = 0;
    var dragging = false;
    var pointerId = null;
    var surface = viewport || root;

    function width() {
      return surface.getBoundingClientRect().width || 1;
    }

    function paint(offsetPx, animate) {
      track.style.transition = animate ? '' : 'none';
      var pct = -index * 100 + (offsetPx / width()) * 100;
      track.style.transform = 'translateX(' + pct + '%)';
    }

    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      if (i !== index) pauseVideos(root);
      index = i;
      paint(0, true);
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (dot, n) {
        var on = n === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-index') || '0', 10));
      });
    });

    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(index + 1);
      }
    });

    function isChrome(el) {
      return !!(el && el.closest && el.closest('video, button, a'));
    }

    function onPointerDown(e) {
      if (slides.length < 2) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (isChrome(e.target)) return;
      dragging = true;
      pointerId = e.pointerId;
      startX = e.clientX;
      deltaX = 0;
      surface.classList.add('is-dragging');
      paint(0, false);
      try {
        surface.setPointerCapture(e.pointerId);
      } catch (err) {}
      e.preventDefault();
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      deltaX = e.clientX - startX;
      paint(deltaX, false);
    }

    function onPointerUp(e) {
      if (!dragging) return;
      if (e && pointerId != null && e.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
      surface.classList.remove('is-dragging');
      try {
        if (e) surface.releasePointerCapture(e.pointerId);
      } catch (err) {}
      var threshold = Math.max(THRESHOLD_PX, width() * THRESHOLD_RATIO);
      if (deltaX > threshold) go(index - 1);
      else if (deltaX < -threshold) go(index + 1);
      else go(index);
      deltaX = 0;
    }

    surface.addEventListener('pointerdown', onPointerDown);
    surface.addEventListener('pointermove', onPointerMove);
    surface.addEventListener('pointerup', onPointerUp);
    surface.addEventListener('pointercancel', onPointerUp);
    surface.addEventListener('lostpointercapture', onPointerUp);
    surface.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    go(0);
  }

  function boot() {
    document.querySelectorAll('[data-mm-slideshow]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
